import { directive as s } from "../beacon-directive.d/index.js";
import { UnsafeHTMLDirective as t } from "../beacon-unsafe-html.d/index.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class e extends t {
}
e.directiveName = "unsafeSVG", e.resultType = 2;
const o = s(e);
export {
  o as unsafeSVG
};
